// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1nE2J","description":"PatientConsentPreview_description__jmaKU"};